import PropTypes from 'prop-types';

export default class Link extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onClick = ::this.onClick;
  }

  static propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    to: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.func]),
  };

  static defaultProps = {
    className: '',
    title: null,
  };

  onClick(event) {
    event.preventDefault();
    const { to } = this.props;
    if (event.ctrlKey) {
      window.open(`${window.location.pathname}#${to}`);
      return;
    }

    window.location.hash = to;
  }

  render() {
    const { to, children, title, className } = this.props;

    return (
      <a
        href={`${window.location.pathname}#${to}`}
        className={`Edocat-Router-Link ${className}`}
        onClick={this.onClick}
        title={title}
      >
        {children}
      </a>
    );
  }
}
